import React, { memo } from "react";
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from '@chakra-ui/react'
import { AccordionList } from "../../molecules/SidebarAccordionPanelList";
import { AccordionItemLink } from "../../molecules/SidebarAccordionItemLink";


export const SoCouponAccordionMenu = () => {
  return (
    <AccordionItem border='none'>
      <AccordionButton px='10px' py={0}>
        <Box as="span" flex='1' textAlign='left' fontWeight='bold'>
          即ーポン
        </Box>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel>
        <AccordionList>
          <AccordionItemLink to={`socoupon/qr-code`} text="QRコード" />
          <AccordionItemLink to={`socoupons`} text="クーポン一覧" />
          <AccordionItem border='none'>
            <AccordionButton px='10px' py={1} >
              <Box flex='1' textAlign='left' fontWeight='bold'>
                アンケート
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>
              <AccordionList>
                <AccordionItemLink to={`socoupon/survey/questions`} text="アンケート設定" />
                <AccordionItemLink to={`socoupon/survey/questions/selected`} text="アンケートセット" />
              </AccordionList>
            </AccordionPanel>
          </AccordionItem>
          <AccordionItemLink to={`socoupon/scores`} text="データ解析" />
          <AccordionItemLink to={`socoupon/setting`} text="設定" />
        </AccordionList>
      </AccordionPanel>
    </AccordionItem>
  );
};